<template>
  <div v-loading="loading" class="archiving-detail">
    <common-bg-plate>
      <el-alert
        title="注意"
        type="warning"
        description="归档数据已加密，显示信息为密文"
        :closable="false"
        show-icon
      >
      </el-alert>
      <detail-table :title="title1" :table-col="tableCol1" :list="list1"></detail-table>
      <detail-table :title="title2" :table-col="tableCol2" :list="list2"></detail-table>
      <detail-section title="交易信息" class="transcation-detail">
        <normal-table
          v-loading="txLoading"
          :table-data="txList"
          :table-col="labelList"
          :paging="paging"
          :show-edit="showDetails"
          :operator="operator"
          @pagination="handleSizeOrPageChange"
        ></normal-table>
      </detail-section>
    </common-bg-plate>
  </div>
</template>

<script>
import timeImg from '@/assets/images/tableIcon/time.png'
import hashImg from '@/assets/images/tableIcon/hash.png'
import frontHashImg from '@/assets/images/tableIcon/front-hash.png'
import readWriteHashImg from '@/assets/images/tableIcon/read-write-hash.png'
import heightImg from '@/assets/images/tableIcon/height.png'
import organizationImg from '@/assets/images/tableIcon/organization.png'
import merkelImg from '@/assets/images/tableIcon/merkel.png'
import dagFeaturesImg from '@/assets/images/tableIcon/dag-features.png'
import cdnNodeImg from '@/assets/images/tableIcon/cdn-node.png'

import { mapState, mapActions } from 'vuex'
export default {
  name: 'ArchivingDetail',
  components: {},
  data() {
    return {
      operator: [
        {
          text: '查看',
          click: row => {
            return this.goTxDetailFn(row)
          },
          icon: 'icon-check'
        }
      ],
      title1: '区块基本信息',
      tableCol1: [
        { label: '区块Hash', icon: hashImg, value: 'blockHash' },
        { label: '区块高度', icon: heightImg, value: 'blockHeight' },
        { label: '前区块Hash', icon: frontHashImg, value: 'preBlockHash' },
        { label: '时间戳', icon: timeImg, value: 'createAt' }
      ],
      list1: {},
      title2: '其他信息',
      tableCol2: [
        { label: '读写集哈希', icon: readWriteHashImg, value: 'rwSetHash' },
        { label: '交易默克尔根', icon: merkelImg, value: 'txRootHash' },
        { label: 'DAG特征值', icon: dagFeaturesImg, value: 'dagHash' },
        { label: '出块组织', icon: organizationImg, value: 'OrgId' },
        { label: '出块节点', icon: cdnNodeImg, value: 'proposer_id' }
      ],
      list2: {},
      //交易信息
      showDetails: true,
      labelList: [
        { label: '交易ID', prop: 'txId' },
        { label: '发起组织', prop: 'orgId' },
        { label: '目标合约', prop: 'contractName' },
        { label: '上链时间', prop: 'createAt' },
        { label: '发起用户', prop: 'sender' },
        { label: '交易状态', prop: 'txStatusCode' }
      ],
      // 加载中
      loading: true,
      txLoading: true,
      paging: {
        limit: 10,
        offset: 0,
        total: 0
      },
      txList: []
    }
  },
  computed: {
    ...mapState({
      detail: state => state.chain.archiving_info
    })
  },
  mounted() {
    this.loading = false
    if (this.detail && this.detail.block && this.detail.block.header) {
      this.setParamsFn(this.detail.block.header)
    }
    if (this.detail && this.detail.block && this.detail.block.txs) {
      this.setTxParamsFn(this.detail.block.txs)
    }
    this.$nextTick(() => {
      this.txLoading = false
    })
  },
  methods: {
    ...mapActions(['getTxnLists']),
    // 获取详情并赋值
    setParamsFn(params = {}) {
      this.list1 = {
        blockHash: params.block_hash,
        blockHeight: params.block_height,
        preBlockHash: params.pre_block_hash,
        createAt: this.formatTime(params.block_timestamp * 1000)
      }
      this.list2 = {
        rwSetHash: params.rw_set_root,
        txRootHash: params.tx_root,
        dagHash: params.dag_hash,
        OrgId: params.proposer.org_id,
        proposer_id: this.$constants.EMPTY
      }
    },
    formatTime(time) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', time)
    },
    setTxParamsFn(params = {}) {
      this.paging.total = params.length
      let rtxList = []
      for (let i = 0; i < params.length; i++) {
        let item = params[i]
        rtxList.push({
          txId: item.payload.tx_id,
          orgId: item.sender.signer.org_id,
          contractName: item.payload.contract_name,
          createAt: this.formatTime(item.payload.timestamp),
          sender: this.$constants.EMPTY,
          txStatusCode: item.result.code
        })
      }

      this.txList = rtxList.slice(params.offset, params.limit)
    },
    // 获取交易列表
    getTxnListFn(params = {}) {
      params.offset = params.offset || 0
      params.limit = params.limit || 10

      if (this.detail && this.detail.block && this.detail.block.txs) {
        this.setTxParamsFn(this.detail.block.txs)
      }
      this.$nextTick(() => {
        this.txLoading = false
      })
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getTxnListFn({limit: limit, offset: offset * limit})
    },
    goTxDetailFn(row) {
      this.$router.push({
        name: 'archivingTxnDetail',
        query: {
          txId: row.txId,
          chainId: this.$route.query.chainId
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'archiving-detail',
  (
    --archiving-detail-list-operate-color: #45c2ff,
    --archiving-detail-list-operate-danger-color: #e95757
  ),
  (
    --archiving-detail-list-operate-color: #45c2ff,
    --archiving-detail-list-operate-danger-color: #e95757
  )
);
.archiving-detail {
  @include adaptation(
    (
      --archiving-detail-unavaliable-height: 678px,
      --archiving-detail-common-bg-plate-padding: 16px 16px 0,
      --archiving-detail-detail-section-padding: 4px 0,
      --archiving-detail-trascation-section-padding: 4px 0 0,
      --archiving-detail-trascation-section-content-padding: 4px 0 0,
    )
  );
  --archiving-detail-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--archiving-detail-unavaliable-height)
  );

  .common-bg-plate {
    min-height: var(--base-main-router-body-avaliable-height);
    padding: var(--archiving-detail-common-bg-plate-padding);
  }

  .cbaas-detail-table {
    /deep/ .cbaas-detail-section {
      padding: var(--archiving-detail-detail-section-padding);
    }
  }

  .cbaas-detail-section.transcation-detail {
    padding: var(--archiving-detail-trascation-section-padding);

    /deep/ .content {
      padding: var(--archiving-detail-trascation-section-content-padding);
    }
  }

  .normal-table-wrap {
    height: 100%;
    min-height: var(--archiving-detail-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--archiving-detail-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--archiving-detail-min-height);

        .operate-item {
          color: var(--archiving-detail-list-operate-color);

          &.operate-danger {
            color: var(--archiving-detail-list-operate-danger-color);
          }
        }
      }
    }
  }
}
</style>
